import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import update from 'immutability-helper';
import './ConsultantReferralForm.scss';
import grayLogo from '../../../assets/images/Logo_Gray.svg';
import ConsultantForm from '../Registration/ConsultantForm';
import ConsultantReferralsReceived from './ConsultantReferralsReceived';
import SignInForm from '../SignInForm';
import ExpertiseTagDropdown from '../common/ExpertiseTagDropdown';
import { postRequest, getRequest } from '../../requestUtils';
import { emailRegex } from '../../formValidators';
var maxItems = 100;
var filterPicklist = function filterPicklist(picklist, input) {
  return picklist.filter(function (record) {
    return record.label.toLowerCase().includes(input.toLowerCase());
  }).slice(0, maxItems);
};
var ConsultantReferralForm = /*#__PURE__*/function (_Component) {
  function ConsultantReferralForm(props) {
    var _this;
    _classCallCheck(this, ConsultantReferralForm);
    _this = _callSuper(this, ConsultantReferralForm, [props]);
    _this.state = {
      step: 'invite-consultants',
      consultants: [{
        name: '',
        validName: true,
        email: '',
        validEmail: true,
        id: "0".concat(Date.now()),
        linkedInUrl: '',
        selectedAoe: [],
        isSelectedAoe: true
      }],
      recommendationIds: [],
      referrerName: '',
      validReferrerName: true,
      picklist: []
    };
    _this.switchToStep = _this.switchToStep.bind(_this);
    _this.addNewConsultantFields = _this.addNewConsultantFields.bind(_this);
    _this.removeConsultant = _this.removeConsultant.bind(_this);
    _this.updateField = _this.updateField.bind(_this);
    _this.consultantFields = _this.consultantFields.bind(_this);
    _this.createRecommendations = _this.createRecommendations.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.getProjectDetails = _this.getProjectDetails.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }
  _inherits(ConsultantReferralForm, _Component);
  return _createClass(ConsultantReferralForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getProjectDetails();
    }
  }, {
    key: "getProjectDetails",
    value: function getProjectDetails() {
      var _this2 = this;
      getRequest('/recommendations/aoe_select_options').then(function (_ref) {
        var data = _ref.data;
        _this2.setState({
          picklist: data
        });
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "switchToStep",
    value: function switchToStep(step) {
      var _this3 = this;
      return function () {
        return _this3.setState({
          step: step
        });
      };
    }
  }, {
    key: "addNewConsultantFields",
    value: function addNewConsultantFields() {
      var consultants = this.state.consultants;
      this.setState({
        consultants: update(consultants, {
          $push: [{
            name: '',
            validName: true,
            email: '',
            validEmail: true,
            id: "".concat(consultants.length).concat(Date.now()),
            linkedInUrl: '',
            selectedAoe: [],
            isSelectedAoe: true
          }]
        })
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm(referrerName, consultants) {
      var validReferrerName = this.state.validReferrerName;
      var anonymous = this.props.anonymous;
      var allValid = true;
      var validatedConsultants = [];
      if (anonymous) {
        this.setState({
          validReferrerName: referrerName.length > 0
        });
      }
      consultants.forEach(function (consultant) {
        var index = consultants.findIndex(function (c) {
          return c.id === consultant.id;
        });
        var validatedConsultant = update(consultant, {
          validName: {
            $apply: function $apply() {
              return consultant.name.length > 0;
            }
          },
          validEmail: {
            $apply: function $apply() {
              return emailRegex.test(consultant.email);
            }
          },
          isSelectedAoe: {
            $apply: function $apply() {
              return consultant.selectedAoe.length > 0;
            }
          }
        });
        validatedConsultants[index] = validatedConsultant;
        if (consultant.name.length <= 0 || !emailRegex.test(consultant.email) || consultant.selectedAoe.length === 0) {
          allValid = false;
        }
      });
      this.setState({
        consultants: validatedConsultants
      });
      return allValid && validReferrerName;
    }
  }, {
    key: "createRecommendations",
    value: function createRecommendations() {
      var _this4 = this;
      var _this$props = this.props,
        createRecommendationsPath = _this$props.createRecommendationsPath,
        csrfToken = _this$props.csrfToken,
        projectId = _this$props.projectId,
        anonymous = _this$props.anonymous;
      var _this$state = this.state,
        consultants = _this$state.consultants,
        referrerName = _this$state.referrerName;
      if (this.validateForm(referrerName, consultants)) {
        consultants.forEach(function (consultant) {
          consultant.linked_in_url = consultant.linkedInUrl;
          consultant.area_of_expertise = consultant.selectedAoe.map(function (_ref2) {
            var name = _ref2.label,
              id = _ref2.value;
            return {
              id: id,
              name: name
            };
          });
        });
        postRequest(createRecommendationsPath, {
          project_id: projectId,
          referrer_name: referrerName,
          recommendations: consultants
        }, csrfToken).then(function (_ref3) {
          var data = _ref3.data;
          var recommendationIds = data.recommendation_ids;
          if (recommendationIds.length) {
            _this4.setState({
              step: anonymous ? 'signup' : 'thank-you',
              recommendationIds: recommendationIds
            });
          }
        })["catch"](function () {
          return _this4.setState({
            recommendationError: 'Something has gone wrong. Please try again later.'
          });
        });
      }
    }
  }, {
    key: "removeConsultant",
    value: function removeConsultant(consultant) {
      var _this5 = this;
      return function (event) {
        event.preventDefault();
        var consultants = _this5.state.consultants;
        var index = consultants.findIndex(function (elem) {
          return elem.id === consultant.id;
        });
        if (index === -1) {
          return;
        }
        _this5.setState({
          consultants: update(consultants, {
            $splice: [[index, 1]]
          })
        });
      };
    }
  }, {
    key: "updateField",
    value: function updateField(fieldName, consultant) {
      var _this6 = this;
      return function (event) {
        var consultants = _this6.state.consultants;
        var index = consultants.findIndex(function (elem) {
          return elem.id === consultant.id;
        });
        if (index === -1) {
          return;
        }
        var newConsultant = _objectSpread({}, consultants[index]);
        newConsultant[fieldName] = event.target.value;
        _this6.setState({
          consultants: update(consultants, {
            $splice: [[index, 1, newConsultant]]
          })
        });
      };
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(model, multi, id) {
      var _this7 = this;
      var consultants = this.state.consultants;
      var newConsultants = _toConsumableArray(consultants);
      return function (tags) {
        var consultantIndex = newConsultants.findIndex(function (c) {
          return c.id === id;
        });
        if (consultantIndex !== -1) {
          newConsultants[consultantIndex] = _objectSpread(_objectSpread({}, newConsultants[consultantIndex]), {}, {
            selectedAoe: tags
          });
          _this7.setState({
            consultants: newConsultants
          });
        }
      };
    }
  }, {
    key: "consultantFields",
    value: function consultantFields() {
      var _this8 = this;
      var _this$state2 = this.state,
        consultants = _this$state2.consultants,
        picklist = _this$state2.picklist;
      return consultants.map(function (consultant) {
        return /*#__PURE__*/React.createElement("div", {
          className: "consultant-fields",
          key: "consultant-".concat(consultant.id)
        }, /*#__PURE__*/React.createElement("div", {
          className: "float-end remove-consultant ".concat(consultants.length === 1 && 'd-none')
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "bg-danger",
          onClick: _this8.removeConsultant(consultant)
        }, "\xD7")), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "consultant-name-".concat(consultant.id),
          className: "medium-weight"
        }, "Consultant name", /*#__PURE__*/React.createElement("div", {
          className: "heading-required"
        }, "* Required")), !consultant.validName && /*#__PURE__*/React.createElement("div", {
          className: "text-danger body-text-3 regular"
        }, "Please fill in this field."), /*#__PURE__*/React.createElement("input", {
          type: "text",
          id: "consultant-name-".concat(consultant.id),
          className: "form-control fs-hide",
          placeholder: "Jane Doe",
          onChange: _this8.updateField('name', consultant)
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "email-".concat(consultant.id),
          className: "medium-weight"
        }, "Email", /*#__PURE__*/React.createElement("div", {
          className: "heading-required"
        }, "* Required")), !consultant.validEmail && /*#__PURE__*/React.createElement("div", {
          className: "text-danger body-text-3 regular"
        }, "Please enter a valid email address."), /*#__PURE__*/React.createElement("input", {
          type: "email",
          id: "email-".concat(consultant.id),
          className: "form-control fs-hide",
          placeholder: "janedoe@gmail.com",
          onChange: _this8.updateField('email', consultant)
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "consultant-name-".concat(consultant.id),
          className: "medium-weight"
        }, "LinkedIn Url"), /*#__PURE__*/React.createElement("input", {
          type: "text",
          id: "consultant-name-".concat(consultant.id),
          className: "form-control fs-hide",
          onChange: _this8.updateField('linkedInUrl', consultant)
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, !consultant.isSelectedAoe && /*#__PURE__*/React.createElement("div", {
          className: "text-danger body-text-3 regular"
        }, "Select at least 1 functional area"), /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
          model: "area_of_expertise",
          selection: consultant.selectedAoe,
          handleSelect: function handleSelect(model, multi) {
            return _this8.handleSelect(model, multi, consultant.id);
          },
          multi: true,
          heading: "Functional Areas",
          showMenuFooter: false,
          picklist: picklist,
          loadOptions: function loadOptions(input) {
            return new Promise(function (resolve) {
              resolve(filterPicklist(picklist, input));
            });
          }
        })));
      });
    }
  }, {
    key: "progressBar",
    value: function progressBar() {
      var anonymous = this.props.anonymous;
      var step = this.state.step;
      if (!anonymous) {
        return null;
      }
      var inviteStep = step === 'invite-consultants';
      var rewardStep = step === 'signup' || step === 'signin';
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-3 clearfix"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-6 p-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-2 ps-2 ".concat(inviteStep ? 'accent-emphasis-primary' : 'invisible')
      }, /*#__PURE__*/React.createElement("strong", null, "1. Invite consultants")), /*#__PURE__*/React.createElement("div", {
        className: "small ".concat(inviteStep ? 'bg-accent-emphasis-primary' : 'bg-primary-light')
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        now: 100
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-6 ps-2 pe-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-5 ps-2 ".concat(rewardStep ? 'accent-emphasis-primary' : 'invisible')
      }, /*#__PURE__*/React.createElement("strong", null, "2. Be rewarded")), /*#__PURE__*/React.createElement("div", {
        className: "small ".concat(rewardStep ? 'bg-accent-emphasis-primary' : 'bg-iron')
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        now: rewardStep ? 100 : 0
      }))));
    }
  }, {
    key: "form",
    value: function form() {
      var _this$state3 = this.state,
        step = _this$state3.step,
        recommendationIds = _this$state3.recommendationIds,
        validReferrerName = _this$state3.validReferrerName;
      var anonymous = this.props.anonymous;
      if (step === 'invite-consultants') {
        return /*#__PURE__*/React.createElement("div", {
          className: "invite-consultants p-2 px-md-5 py-md-3"
        }, anonymous && /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "referrer-name",
          className: "medium-weight"
        }, "Tell us your name"), !validReferrerName && /*#__PURE__*/React.createElement("div", {
          className: "text-danger body-text-3 regular"
        }, "Please fill in this field."), /*#__PURE__*/React.createElement("input", {
          type: "text",
          value: this.state.referrerName,
          name: "referrerName",
          id: "referrer-name",
          className: "form-control fs-hide",
          placeholder: "John Doe",
          onChange: this.handleInputChange
        })), /*#__PURE__*/React.createElement("h5", {
          className: "uppercase-bold my-2 text-center"
        }, "YOUR REFERRALS"), this.consultantFields(), /*#__PURE__*/React.createElement("div", {
          className: "mb-3"
        }, /*#__PURE__*/React.createElement("a", {
          href: "# ",
          onClick: this.addNewConsultantFields,
          className: "add-another-referral"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fas fa-plus pe-3"
        }), "Add more referrals")), /*#__PURE__*/React.createElement("input", {
          type: "submit",
          value: "Send invites",
          onClick: this.createRecommendations,
          className: "btn btn-primary",
          id: "consultant-create-recommendations"
        }));
      }
      if (step === 'signup') {
        return /*#__PURE__*/React.createElement("div", {
          className: "signup"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-3"
        }, "Join Clora to get your reward and track the progress of your referrals in the platform."), /*#__PURE__*/React.createElement("div", {
          className: "mb-3"
        }, /*#__PURE__*/React.createElement("strong", {
          className: "medium-demibold"
        }, "Already have an account?", ' ', /*#__PURE__*/React.createElement("a", {
          href: "# ",
          className: "ms-2",
          id: "recommendation-sign-in",
          onClick: this.switchToStep('signin')
        }, "Log In"))), /*#__PURE__*/React.createElement(ConsultantForm, _extends({
          userName: this.state.referrerName
        }, this.props), /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "recommendation_ids",
          value: recommendationIds
        })));
      }
      if (step === 'signin') {
        return /*#__PURE__*/React.createElement("div", {
          className: "signin"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-3"
        }, "Join Clora to get your reward and track the progress of your referrals in the platform."), /*#__PURE__*/React.createElement("div", {
          className: "mb-3"
        }, /*#__PURE__*/React.createElement("strong", null, "Don't have an account?", ' ', /*#__PURE__*/React.createElement("a", {
          href: "# ",
          className: "ms-2",
          id: "recommendation-sign-up",
          onClick: this.switchToStep('signup')
        }, "Sign Up"))), /*#__PURE__*/React.createElement(SignInForm, _extends({}, this.props, {
          submitId: "consultant-sign-in"
        }), /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "recommendation_ids",
          value: recommendationIds
        })));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
        step = _this$state4.step,
        recommendationIds = _this$state4.recommendationIds;
      var referralsPath = this.props.referralsPath;
      if (step === 'thank-you') {
        return /*#__PURE__*/React.createElement(ConsultantReferralsReceived, {
          notOne: recommendationIds.length !== 1,
          referralsPath: referralsPath
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "modal-style style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center title mb-3"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: grayLogo,
        alt: "",
        height: "38",
        width: "90"
      })), /*#__PURE__*/React.createElement("h1", {
        className: "modal-header"
      }, "Connect consultants with relevant projects matching their interests and expertise."), /*#__PURE__*/React.createElement("div", {
        className: "subtext"
      }, "Earn $500 when your referral matches a project!")), /*#__PURE__*/React.createElement("div", {
        className: "form-wrapper"
      }, this.progressBar(), this.form()));
    }
  }]);
}(Component);
ConsultantReferralForm.propTypes = {
  createRecommendationsPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  anonymous: PropTypes.bool.isRequired,
  referralsPath: PropTypes.string.isRequired
};
export default ConsultantReferralForm;